import { Seo } from "../components/Seo";
import Hero from "../components/sections/Hero";
import BuiltAround from "../components/sections/BuiltAround";
import ServicesGrid from "../components/sections/ServicesGrid";
import RetailFocus from "../components/sections/RetailFocus";
import WhyUs from "../components/sections/WhyUs";
import Emergency from "../components/sections/Emergency";
import ProjectsGrid from "../components/sections/ProjectsGrid";
import ServiceArea from "../components/sections/ServiceArea";
import CtaBand from "../components/sections/CtaBand";
import { Marquee } from "../components/Marquee";
import { SERVICES } from "../lib/data";

const Home = () => (
  <main data-testid="home-page">
    <Seo
      title="Petroline Services | Petroleum Retail Contracting & Maintenance Ontario"
      description="Petroline Services provides commercial contracting, renovations, repairs and facility-maintenance services for gas stations, car washes and petroleum retail facilities across Southern Ontario."
    />
    <Hero />
    <Marquee items={SERVICES.map((s) => s.title)} testId="home-services-marquee" />
    <BuiltAround />
    <ServicesGrid />
    <RetailFocus />
    <WhyUs />
    <Emergency />
    <ProjectsGrid limit={4} />
    <ServiceArea />
    <CtaBand />
  </main>
);

export default Home;
